// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3zs4R","additionalInfo":"AgreementModal_additionalInfo__2Dw4j"};